/**
 * Created by rathompson on 6/10/22
 * File: ConnectedTableFilter
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useEffect, useRef, useState, VFC } from 'react'
import { useAsyncDebounce } from './utils'
import { TableFilter } from './TableFilter'
import { useTableInstance } from '@panwds/react-table'

export const InstanceTableFilter: VFC<{
  placeholder: string,
  searchCallback?: Function,
  instance: any
}> = ({ placeholder, searchCallback, instance }) => {
  const { setGlobalFilter, state } = instance ?? {}
  const { globalFilter = '' } = state ?? {}

  const [value, setLocalValue] = useState(globalFilter)

  const setGlobalValue = useAsyncDebounce((v: any) => {
    setGlobalFilter(v)
  }, 200)

  const onClear = useCallback(() => {
    setLocalValue('')
    setGlobalFilter('')
  }, [setGlobalFilter])

  return (
    <TableFilter
      onChange={(e: any) => {
        const v = e.currentTarget.value
        setLocalValue(v)
        setGlobalValue(v)
        if (searchCallback && typeof searchCallback === 'function') {
          searchCallback(v)
        }
      }}
      placeholder={placeholder}
      value={value}
      onClear={onClear}
    />
  )
}

export const ConnectedTableFilter: VFC<{
  placeholder: string,
  searchCallback?: Function
}> = ({ placeholder, searchCallback }) => {
  const {
    autoResetGlobalFilter,
    data,
    setGlobalFilter,
    state: { globalFilter = '' },
  } = useTableInstance()

  const componentMounted = useRef(false)
  const [value, setLocalValue] = useState(globalFilter)

  const setGlobalValue = useAsyncDebounce((v: any) => {
    setGlobalFilter(v)
  }, 200)

  useEffect(() => {
    if (!componentMounted.current) {
      componentMounted.current = true
    }
    else if (autoResetGlobalFilter) {
      setLocalValue('')
      setGlobalFilter('')
    }
  }, [autoResetGlobalFilter, data, setGlobalFilter])

  const onClear = useCallback(() => {
    setLocalValue('')
    setGlobalFilter('')
  }, [setGlobalFilter])

  return (
    <TableFilter
      onChange={(e: any) => {
        const v = e?.currentTarget?.value
        setLocalValue(v)
        setGlobalValue(v)
        if (searchCallback && typeof searchCallback === 'function') {
          searchCallback(v)
        }
      }}
      placeholder={placeholder}
      value={value}
      onClear={onClear}
    />
  )
}

ConnectedTableFilter.propTypes = {}
export default ConnectedTableFilter
